import { submitDemographicInfo } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type {
  SubmitDemographicInfoRequestT,
  DosespotIDPRecordT,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';
import { logger } from '@/shared';

/**
 * Submit demographic information for IDP verification.
 */
export async function fetchSubmitDemographicInfo(
  data: SubmitDemographicInfoRequestT,
  signal?: AbortSignal
): Promise<DosespotIDPRecordT> {
  const config = await createLotusRequestConfig({ signal });
  const response = await submitDemographicInfo(data, config);
  const result = lotusHealthZod.submitDemographicInfoResponse.parse(
    response.data
  ) as DosespotIDPRecordT;

  logger.info('dosespot.idp.submitDemographicInfo', {
    source: 'entities/dosespot-idp/api',
    currentState: result.current_state,
  });

  return result;
}
